import { B2bPartnershipType } from 'common/B2BVerification/constants'
import { sessionStorageKeys } from 'constants/common'
import qs from 'qs'
import { ParsedUrlQuery } from 'querystring'

export const formatAndValidateB2bDetails = (
  b2bPartnerDetails: BusinessPartner,
  partnershipCodeFromQuery: string,
  isPatient: boolean
): B2BDetails => {
  b2bPartnerDetails.partnershipCode = partnershipCodeFromQuery
  const { id, dealStructure } = b2bPartnerDetails ?? {}
  const isGoldPartnerClient =
    isPatient &&
    (dealStructure === B2bPartnershipType.FULLY_COVERED ||
      dealStructure === B2bPartnershipType.NON_CONFORMING)

  /*
    Return undefined to reset b2b details state if the partnership is not valid
    or the partner type is fully-covered or non-conforming for client user
  */
  if (!id || isGoldPartnerClient) {
    return undefined
  }

  const formattedB2bDetails = convertToB2bDetails(b2bPartnerDetails)
  return formattedB2bDetails
}

export const convertToB2bDetails = (
  b2bPartnerDetails: BusinessPartner
): B2BDetails => {
  const {
    id,
    name,
    partnershipCode,
    hidePaymentInput,
    hideInsuranceInput,
    hidePostBookingModalCopy,
    customSuccessMessage,
    customFailureMessage,
    authorizationRequired,
    channelType,
    dealStructure,
    isCreditCardOptional,
  } = b2bPartnerDetails ?? {}
  return {
    partnerId: id,
    partnerName: name,
    isB2BUser: true,
    keyword: partnershipCode,
    flags: {
      hideInsurance: hideInsuranceInput,
      hidePayment: hidePaymentInput,
      hidePostBookingModalCopy: hidePostBookingModalCopy,
      isCreditCardOptional,
    },
    verificationMessages: {
      customSuccessMessage: customSuccessMessage,
      customFailureMessage: customFailureMessage,
    },
    authorizationRequired,
    ...(channelType && { channelType }),
    ...(dealStructure && { dealStructure }),
  }
}

export const addKeywordToStoredSearchQuery = (
  partnershipCode: string
): void => {
  const storedProviderSearchQuery = JSON.parse(
    sessionStorage.getItem(sessionStorageKeys.PROVIDER_SEARCH_QUERY)
  )
  sessionStorage.setItem(
    sessionStorageKeys.PROVIDER_SEARCH_QUERY,
    JSON.stringify({
      ...storedProviderSearchQuery,
      partnershipCode,
    })
  )
}

export const extractKeywordFromQuery = (query: ParsedUrlQuery): string => {
  const { redirectTo, partnershipCode } = query ?? {}
  let b2bPartnershipCode

  if (!!redirectTo) {
    const redirectToQuery = (redirectTo as string).split('?')[1]
    const redirectUrlQueryParams = qs.parse(redirectToQuery)
    b2bPartnershipCode = redirectUrlQueryParams?.partnershipCode
  } else {
    b2bPartnershipCode = partnershipCode
  }

  return b2bPartnershipCode
}
